import React from 'react';

const cs10AssistantConversation = (
  <div className="space-y-4">
    {/* Assistant Agent Introduction */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Hi Samantha! I noticed you're enjoying a vibrant atmosphere in the living room. Are you diving into a creative project or looking for some relaxation? If you need any adjustments to lights or music, just let me know!
        </div>
      </div>
    </div>

    {/* Samantha's Initial Smart Home Rule Setup */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          When I'm starting a creative design project, the ambient light strip should automatically switch to vibrant mode, the ceiling lights should dim, and an upbeat music playlist should start. This helps spark my creativity and keeps the atmosphere lively and inspiring.
        </div>
      </div>
    </div>

    {/* Assistant Agent's Suggestion on Ambient Adjustment */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          I noticed you've adjusted the curtains to half-open. Would you like me to complement the natural light with a calming music playlist or adjust the ambient lighting further?
        </div>
      </div>
    </div>

    {/* Samantha's Response to Natural Light Scenario */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Yes, please! When the curtains open to let natural sunlight in, switch the ambient light strip to a soft, warm color and play calming instrumental music at a low volume. It helps balance natural and artificial lighting, making my workspace more inviting and energizing.
        </div>
      </div>
    </div>

    {/* Assistant Agent Checks in after Coffee Brewing */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          You've just brewed some coffee—would you like me to further enhance the atmosphere with specific lighting or music adjustments?
        </div>
      </div>
    </div>

    {/* Samantha's Coffee Break Rule Description */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Whenever I brew coffee, please automatically adjust the ambient lighting to vibrant colors, set the curtains to half-open, and play an upbeat music playlist. This vibrant setup energizes my creativity and makes it easy to transition back into my design work.
        </div>
      </div>
    </div>

    {/* Assistant Agent's Offer after Meditation */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          After your guided meditation session, would you like assistance setting up a relaxing transition environment or returning smoothly to your creative tasks?
        </div>
      </div>
    </div>

    {/* Samantha's Meditation Transition Rule Description */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          When I finish my guided meditation, dim the lights to a soft glow and set the ambient strip to warm, calming colors. Play gentle music quietly to enhance the relaxing environment. This creates a seamless transition from meditation back into my creative or relaxation routine.
        </div>
      </div>
    </div>

    {/* Assistant Agent Final Check-In */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Thanks for sharing your preferences, Samantha! Let me know if there's anything else you'd like to customize or if you'd like additional suggestions for creating your ideal environment.
        </div>
      </div>
    </div>
  </div>
);

export default cs10AssistantConversation;